"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotiState =
/** @class */
function () {
  function NotiState() {
    var _this = this;

    this.providerContext = undefined;

    this.showMessage = function (message, variant) {
      if (!!_this.providerContext) {
        return _this.providerContext.enqueueSnackbar(message, {
          variant: variant
        });
      }

      return null;
    };

    this.hideMessage = function (key) {
      if (!!_this.providerContext && !!key) {
        _this.providerContext.closeSnackbar(key);
      }
    };
  }

  return NotiState;
}();

exports.default = NotiState;